import { createApp } from "vue";
import { createGtm } from "@gtm-support/vue-gtm";
import ElementPlus, { ElNotification } from "element-plus";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import Vue3Geolocation from "vue3-geolocation";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import i18n from "./i18n";
import "./assets/css/index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import mn from "element-plus/dist/locale/mn";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const app = createApp(App)
  .use(router)
  .use(store)
  .use(Vue3Geolocation)
  .use(ElementPlus, { locale: mn })
  .use(i18n)
  .use(
    createGtm({
      // id: "GTM-PXSF8B4", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      id: "GTM-PXSF8B4", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      // G-9ZGQNQ1ZF5
      // queryParams: {
      //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
      //   gtm_preview: 'env-4',
      //   gtm_cookies_win: 'x'
      // },
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      nonce: "2726c7f26c", // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      ignoredViews: ["homepage"], // Don't trigger events for specified router names (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
      // config: {id: 'G-9ZGQNQ1ZF5'}
    })
  )
  .use(VueGoogleMaps, {
    load: {
      // key: 'AIzaSyBSdReOrwV_HTJySiN9A-XEJ7P79cBTOTg',
      // key: "AIzaSyBSdReOrwV_HTJySiN9A-XEJ7P79cBTOTg",
      key: "AIzaSyCGIRu9jy6Emih4eAmg0Iy3HokUHR77mkw",
      region: "MN",
      language: "mn",
      libraries: "places",
    },
    autobindAllEvents: false,
  })
  .provide("app", {
    isMobile: false,
    monpay: {
      code: null,
      accessToken: null,
    },
    directFrom: null,
    new_reload: true,
    // outlet_description: '',
    // outlet_ident: null,
    order_type_dialog: true,
    // orderType: 'delivery',
    mainCounter: 1,
    // scrollTop: 0,
    // targetName: '',
    // fullscreenLoading: false,
    // full_address: '',
    // order_status: '',
    orderJson: {
      // free_products: [],
      // address: {
      //   addr_orts: '',
      //   addr_orts_code: '',
      //   addr_haalga: '',
      //   addr_note: '',
      //   bairname: '',
      //   bairname2: '',
      //   bairnote: '',
      //   full_address: '',
      //   longitude: '',
      //   latitude: '',
      //   podcode: '',
      //   podph: '',
      //   podkfc: '',
      //   podtoktok: '',
      // },
      // options: {
      //   origin: '',
      //   channel: 'web',
      //   order_type: 0,
      //   advance_order: 0,
      //   promised_time: '',
      //   phone2: '',
      //   pickup_type: '',
      //   pay_type: '',
      //   pay_type_name: '',
      //   customer_note: '',
      //   vat_type: 1,
      //   vat_regno: '',
      //   vat_cust_name: '',
      //   employee: '',
      //   menu_total: 0,
      //   delivery_charge: 0,
      // },
      cust: {
        phone: "",
        email: "",
        customerUser: "",
      },
      // cart: [],
      // outlet: '',
    },
  })
  .provide("notify", ElNotification);
app.config.globalProperties.$formatCurrency = function (value) {
  return new Intl.NumberFormat().format(value) + "₮";
};
app.mount("#app");
